import { ecorEnv } from '@/../environments/environment';
import { PortalUser } from '@/common/components/ecorr-store/portal-user/portal-user';
import * as PortalUserActions from '@/common/components/ecorr-store/portal-user/portal-user.action';
import { PortalUserState } from '@/common/components/ecorr-store/portal-user/portal-user.state';
import { ParadataEventEnum, ParadataEventService } from '@/common/paradata-event/paradata-event.service';
import { WINDOW } from '@/window';
import { Injectable, inject, signal, computed } from '@angular/core';
import { Store } from '@ngrx/store';
import { LocalStorageService, SessionStorage, SessionStorageService } from 'ngx-webstorage';

@Injectable({
    providedIn: 'root'
})
export class EcorrUtilsService {
    private store = inject(Store<PortalUserState>);
    private localStorageService = inject(LocalStorageService);
    private sessionStorageService = inject(SessionStorageService);
    private paradataEventService = inject(ParadataEventService);
    private window = inject(WINDOW);

    @SessionStorage('timedOut') timedOut: boolean;
    
    // Signal-based state management
    private _isIE = computed<boolean>(() => {
        const agent = this.window.navigator.userAgent.toLowerCase();
        return agent.includes('trident') || agent.includes('android');
    });
    
    // Computed properties
    isInternetExplorer = computed(() => this._isIE());

    public isIE(): boolean {
        return this._isIE();
    }

    logout() {
        this.paradataEventService.add(ParadataEventEnum.SignOut);
        this.paradataEventService.flushParadataevents();
        this.store.dispatch(PortalUserActions.setUser({ payload: { portalUser: new PortalUser() } }));

        /**
         * TODO: 2 of 2. The other TODO is in ecorr.guard the logout observer.
         */
        /** TODO start */
        this.sessionStorageService.clear();
        this.localStorageService.clear();
        /** TODO end */

        let endpoint = null;
        if (ecorEnv.cpassEnabled) {
            if (this.timedOut) {
                endpoint = ecorEnv.logoutUrl + ecorEnv.timeoutParams;
            } else {
                endpoint = ecorEnv.logoutUrl;
            }
        } else {
            endpoint = '/portal';
        }

        setTimeout(() => {
            this.window.location.href = endpoint;
        }, 200);
    }
}
